import * as React from 'react';

export default ({size}: {size?: number}) => (
  <svg
    width={size ?? 50}
    height={size ?? 50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z"
      fill="#F7183F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 15L25 25L35 15"
      fill="#F7183F"
    />
    <path
      d="M15 15L25 25M25 25L35 15M25 25L35 35M25 25L15 35"
      stroke="white"
      strokeWidth="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
